'use client'

import dynamic from 'next/dynamic'

const SuburbMapHeroClient = dynamic(() => import('@/components/suburb/SuburbMapHeroClient'), {
  ssr: false,
  loading: () => null,
})

interface SuburbBoundaryMapProps {
  center: [number, number]
  boundary: GeoJSON.Geometry
}

/**
 * Neighbourhood-page map — reuses the established suburb-boundary styling
 * (SuburbMapHeroClient light variant: Carto light tiles, black boundary outline
 * with a subtle fill, auto-fit to the boundary, no pin).
 */
export function SuburbBoundaryMap({ center, boundary }: SuburbBoundaryMapProps) {
  return <SuburbMapHeroClient center={center} boundary={boundary} variant="light" />
}
